import { useCallback, useEffect, useState } from 'react';
import RfsLayout from '../../../components/layouts/RfsLayout';
import ContentPaper from '../../../components/layouts/rfs/Content';
import { axios } from '../../../utils/axios';
import Table from './table';
import { formatAllRequests } from './helper';
import { Header } from '../stockPriceExtension/selectSku';

const Extensions = () => {
  const [loading, setLoading] = useState(false);
  const [requests, setRequests] = useState([]);

  const fetch = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await axios.get('/costing-request/er-ids');
      setRequests(formatAllRequests(data.data || {}));
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return (
    <RfsLayout>
      <ContentPaper>
        <Header heading={'ALL EXTENSIONS'} />
        <Table requests={requests} loading={loading} />
      </ContentPaper>
    </RfsLayout>
  );
};

export default Extensions;
